var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.476 103.933H1.52343C0.682372 103.933 0 103.251 0 102.41V99.5242C0 98.6824 0.682372 98 1.52343 98H102.476C103.317 98 104 98.6824 104 99.5242V102.41C104 103.251 103.317 103.933 102.476 103.933Z",
    fill: "#031C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.803 26.4005H78.1965V98.0663H25.803V26.4005Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6064 20.9994C81.4729 20.9994 82.1759 21.7016 82.1759 22.5688V25.0793C82.1759 25.9466 81.4729 26.6488 80.6064 26.6488H23.3934C22.527 26.6488 21.824 25.9466 21.824 25.0793V22.5688C21.824 21.7024 22.527 20.9994 23.3934 20.9994H80.6064Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8032 42.5468H1.52344C0.682373 42.5468 0 41.8644 0 41.0225V38.4208C0 37.5789 0.682373 36.8973 1.52344 36.8973H25.8032V42.5468Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0205 98.0664H37.9797V76.0043C37.9797 73.6105 39.9205 71.6697 42.3144 71.6697H61.6859C64.0797 71.6697 66.0197 73.6105 66.0197 76.0043V98.0664H66.0205Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4082 71.6699H53.5922V98.0667H50.4082V71.6699Z",
    fill: "#4D86B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26709 42.5469H25.8034V98.0675H2.26709V42.5469Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8203 42.5469H25.8024V98.0675H22.8203V42.5469Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.733 98.0667H78.197V42.5469H101.733V98.0667Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1973 42.5469H81.1973V98.0675H78.1973V42.5469Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4357 54.4413H33.1989C32.2951 54.4413 31.5627 53.7081 31.5627 52.8044V39.1982C31.5627 38.2944 32.2951 37.5613 33.1989 37.5613H38.4357C39.3394 37.5613 40.0718 38.2944 40.0718 39.1982V52.8044C40.0726 53.7081 39.3394 54.4413 38.4357 54.4413Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6183 54.4413H49.3815C48.4777 54.4413 47.7454 53.7081 47.7454 52.8044V39.1982C47.7454 38.2944 48.4777 37.5613 49.3815 37.5613H54.6183C55.522 37.5613 56.2544 38.2944 56.2544 39.1982V52.8044C56.2544 53.7081 55.522 54.4413 54.6183 54.4413Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8009 54.4413H65.5641C64.6603 54.4413 63.928 53.7081 63.928 52.8044V39.1982C63.928 38.2944 64.6603 37.5613 65.5641 37.5613H70.8009C71.7047 37.5613 72.437 38.2944 72.437 39.1982V52.8044C72.437 53.7081 71.7047 54.4413 70.8009 54.4413Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.653 78.7465H11.4169C10.5132 78.7465 9.78003 78.0133 9.78003 77.1096V63.5034C9.78003 62.5996 10.5132 61.8665 11.4169 61.8665H16.653C17.5575 61.8665 18.2899 62.5996 18.2899 63.5034V77.1096C18.2899 78.0141 17.5575 78.7465 16.653 78.7465Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3469 78.7465H92.5829C93.4866 78.7465 94.2198 78.0133 94.2198 77.1096V63.5034C94.2198 62.5996 93.4866 61.8665 92.5829 61.8665H87.3469C86.4423 61.8665 85.71 62.5996 85.71 63.5034V77.1096C85.71 78.0141 86.4423 78.7465 87.3469 78.7465Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.431 36.8973C103.298 36.8973 104 37.5995 104 38.4668V40.9773C104 41.8438 103.298 42.5468 102.431 42.5468H78.197V36.8973H102.431Z",
    fill: "#4B81AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 21V3.42064C66 1.53126 64.4979 0 62.6446 0H40.3554C38.5021 0 37 1.53126 37 3.42064V21H66Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 0V21H67V3.42064C67 1.53126 65.8274 0 64.3805 0H63Z",
    fill: "#2A5B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4017 8.90167H54.0983V5.59833C54.0983 4.71513 53.3832 4 52.5 4C51.6168 4 50.9017 4.71513 50.9017 5.59833V8.90167H47.5983C46.7159 8.90167 46 9.6168 46 10.5C46 11.3824 46.7159 12.0983 47.5983 12.0983H50.9017V15.4009C50.9017 16.2841 51.6168 17 52.5 17C53.3832 17 54.0983 16.2841 54.0983 15.4009V12.0975H57.4017C58.2841 12.0975 59 11.3824 59 10.4992C59 9.6168 58.2841 8.90167 57.4017 8.90167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.c2f173ecc01912b2e1e3b26636d1e8c7.svg";
export { ForwardRef as ReactComponent };